import PageLayout from '@/components/Layouts/PageLayout'
import { motion } from 'framer-motion'
import StyledDiv from '@/components/Render/StyledDiv'
import mixpanel from 'mixpanel-browser'
import Link from 'next/link'
import React, { useEffect } from 'react'
import SignUp from '../components/SignUp'

import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react'

export default function SignUpPage() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    isOpen: isGradOpen,
    onOpen: onGradOpen,
    onClose: onGradClose,
  } = useDisclosure()

  useEffect(() => {
    mixpanel.init('b53e4087bdeef3afa147f7eb9e37140d')
    mixpanel.track('Page View', {
      PageName: 'Sign Up',
    })
  }, [])

  const childVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  return (
    <PageLayout title="Sign Up" isWhite={false}>
      <StyledDiv
        initial={{ y: 10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: '0.8', delay: '0.2' }}
      >
        <div className="flex items-center justify-center flex-wrap">
          <motion.div
            className="flex flex-col justify-center items-center mt-20"
            variants={childVariants}
          >
            <div
              className="flex flex-col nav:flex-row gap-6 justify-center items-center 
              w-[90vw] footerSM:w-[85vw] sm:w-[80vw] xxl:w-[1280px] mt-8 nav:mt-0"
            >
              <Link
                href="/parents"
                className=" bg-blue text-white rounded-lg transition-colors duration-200 footerSM:text-lg xl:text-xl
                py-5 px-8 box-border shadow-lg hover:shadow-lg cursor-pointer hover:bg-blueHover
                font-bold text-center w-[300px] footerSM:w-[350px] nav:w-auto"
              >
                Parents/Community Members
              </Link>
              <button
                className=" bg-blue text-white rounded-lg transition-colors duration-200 footerSM:text-lg xl:text-xl
                py-5 px-8 shadow-lg hover:shadow-lg cursor-pointer hover:bg-blueHover font-bold 
                w-[300px] footerSM:w-[350px] nav:w-auto"
                onClick={onOpen}
              >
                College Students
              </button>
              <Modal isOpen={isOpen} onClose={onClose} isCentered>
                <ModalOverlay />
                <ModalContent>
                  <ModalCloseButton />
                  <ModalBody>
                    <div className="flex flex-col gap-5">
                      <Link
                        className="mt-16 bg-blue text-white rounded-lg transition-colors duration-200 footerSM:text-lg xl:text-xl
                py-5 px-8  shadow-md hover:shadow-lg cursor-pointer hover:bg-blueHover font-bold"
                        href="/seeker"
                      >
                        Looking for a Job/Internship 👀
                      </Link>
                      <Link
                        className="my-10 bg-blue text-white rounded-lg transition-colors duration-200 footerSM:text-lg xl:text-xl
                py-5 px-8  shadow-md hover:shadow-lg cursor-pointer hover:bg-blueHover font-bold"
                        href="/achiever"
                      >
                        Have a Job/Internship ✅
                      </Link>
                    </div>
                  </ModalBody>
                </ModalContent>
              </Modal>
              <button
                className=" bg-blue text-white rounded-lg transition-colors duration-200 footerSM:text-lg xl:text-xl
                py-5 px-8  shadow-lg hover:shadow-lg cursor-pointer hover:bg-blueHover font-bold w-[300px] footerSM:w-[350px] nav:w-auto"
                onClick={onGradOpen}
              >
                Recent College Grads
              </button>
              <Modal isOpen={isGradOpen} onClose={onGradClose} isCentered>
                <ModalOverlay />
                <ModalContent>
                  <ModalCloseButton />
                  <ModalBody>
                    <div className="flex flex-col gap-5">
                      <Link
                        className="mt-16 bg-blue text-white rounded-lg transition-colors duration-200 footerSM:text-lg xl:text-xl
                py-5 px-8  shadow-md hover:shadow-lg cursor-pointer hover:bg-blueHover font-bold"
                        href="/seeker"
                      >
                        Looking for a Job 👀
                      </Link>
                      <Link
                        className="my-10 bg-blue text-white rounded-lg transition-colors duration-200 footerSM:text-lg xl:text-xl
                py-5 px-8  shadow-md hover:shadow-lg cursor-pointer hover:bg-blueHover font-bold"
                        href="/achiever"
                      >
                        Have a Job ✅
                      </Link>
                    </div>
                  </ModalBody>
                </ModalContent>
              </Modal>
            </div>
          </motion.div>
        </div>
        <div className="mt-20">
          <SignUp personType="Sign Up Page" />
        </div>
      </StyledDiv>
    </PageLayout>
  )
}
